import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        { staticClass: "mt-2 pb-3" },
        [
          _c(VImg, {
            staticClass: "rounded primary",
            staticStyle: { position: "relative" },
            attrs: {
              height: "350",
              cover: "",
              src: require("@/assets/portada.png"),
            },
          }),
          _c(
            VContainer,
            [
              _c("div", {
                staticClass: "h1",
                staticStyle: {
                  position: "absolute",
                  left: "150px",
                  right: "0",
                  top: "130px",
                  "z-index": "1",
                },
              }),
              _c(VRow, {
                staticStyle: {
                  position: "absolute",
                  left: "150px",
                  right: "0",
                  top: "200px",
                  "z-index": "0",
                },
                attrs: { dense: "" },
              }),
              _c(
                VRow,
                {
                  staticClass: "pt-3",
                  attrs: { dense: "", justify: "center" },
                },
                [
                  _c(
                    VCol,
                    { staticClass: "mb-3 col-md-3 " },
                    [
                      _c(
                        VCard,
                        {
                          staticClass: " mr-sm-3 ml-sm-3  mr-0 ml-0",
                          staticStyle: { height: "auto" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog(_vm.items[0])
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pa-0", attrs: { align: "center" } },
                            [
                              _c(VImg, {
                                attrs: {
                                  width: "50%",
                                  src: require("@/assets/news.png"),
                                },
                              }),
                              _c(
                                "h3",
                                {
                                  staticClass: "pb-4",
                                  staticStyle: { color: "#81BEF7" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("help_center.news"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "mb-3 col-md-3 " },
                    [
                      _c(
                        VCard,
                        {
                          staticClass: "mx-sm-3  mr-0 ml-0",
                          staticStyle: { height: "auto" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog(_vm.items[1])
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pa-0", attrs: { align: "center" } },
                            [
                              _c(VImg, {
                                attrs: {
                                  width: "50%",
                                  src: require("@/assets/faq.png"),
                                },
                              }),
                              _c(
                                "h3",
                                {
                                  staticClass: "pb-4",
                                  staticStyle: { color: "#81BEF7" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("help_center.read"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "mb-3 col-md-3 " },
                    [
                      _c(
                        VCard,
                        {
                          staticClass: "mr-sm-3 ml-sm-3 mr-0 ml-0",
                          staticStyle: { height: "auto" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog(_vm.items[2])
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pa-0", attrs: { align: "center" } },
                            [
                              _c(VImg, {
                                attrs: {
                                  width: "50%",
                                  src: require("@/assets/video.png"),
                                },
                              }),
                              _c(
                                "h3",
                                {
                                  staticClass: "pb-4",
                                  staticStyle: { color: "#81BEF7" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("help_center.videos"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { staticClass: "mb-3 col-md-3" },
                    [
                      _c(
                        VCard,
                        {
                          staticClass: "mr-sm-3 ml-sm-3 mr-0 ml-0",
                          staticStyle: { height: "auto" },
                          on: {
                            click: function ($event) {
                              return _vm.openDialog(_vm.items[3])
                            },
                          },
                        },
                        [
                          _c(
                            VCardText,
                            { staticClass: "pa-0", attrs: { align: "center" } },
                            [
                              _c(VImg, {
                                attrs: {
                                  width: "50%",
                                  src: require("@/assets/sugerence.png"),
                                },
                              }),
                              _c(
                                "h3",
                                {
                                  staticClass: "pb-4",
                                  staticStyle: { color: "#81BEF7" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("help_center.feedback"))
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                VRow,
                { attrs: { dense: "", justify: "center" } },
                [
                  _c(
                    VCol,
                    { staticClass: "pl-4" },
                    [
                      _vm.onIsAdminUser()
                        ? _c(
                            VBtn,
                            {
                              staticStyle: { color: "#81BEF7" },
                              on: { click: _vm.openAdmin },
                            },
                            [
                              _c(VIcon, [_vm._v("mdi-pencil")]),
                              _vm._v("ADMIN"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "DialogsComponent",
        { ref: "dialog", attrs: { custom_title: "", width: 1200 } },
        [
          _c(
            "template",
            { slot: "title" },
            [
              _c(
                VCol,
                { staticClass: "pl-0", attrs: { cols: "3" } },
                [
                  _c(VSelect, {
                    staticClass: "pl-0",
                    attrs: {
                      rounded: "",
                      small: "",
                      dense: "",
                      "hide-details": "auto",
                      items: _vm.items,
                      "prepend-inner-icon": "mdi-chevron-down",
                      "append-icon": "",
                    },
                    model: {
                      value: _vm.tab,
                      callback: function ($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "body" },
            [
              _c("list_elements", {
                ref: "sugerences",
                attrs: { element: _vm.tab },
              }),
            ],
            1
          ),
          _vm.tab == _vm.items[3]
            ? _c(
                "template",
                { slot: "btnsRight" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs["sugerences"].onSubmit()
                        },
                      },
                    },
                    [
                      _c(
                        VIcon,
                        { staticClass: "mr-1", attrs: { small: "" } },
                        [_vm._v("icon-send")]
                      ),
                      _vm._v("Enviar"),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _c(
        "DialogsComponent",
        { ref: "videos", attrs: { title: "Videos", width: 1200 } },
        [_c("template", { slot: "body" }, [_c("videos")], 1)],
        2
      ),
      _c(
        "DialogsComponent",
        {
          ref: "sugerences",
          attrs: { title: "Buzón de sugerencias", width: 800 },
        },
        [
          _c("template", { slot: "body" }, [_c("sugerences")], 1),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              _c(
                VBtn,
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs["sugerences"].onSubmit()
                    },
                  },
                },
                [
                  _c(VIcon, { staticClass: "mr-1", attrs: { small: "" } }, [
                    _vm._v("icon-send"),
                  ]),
                  _vm._v("Enviar"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }